import Button from 'components/Button'
import ButtonCollection from 'components/ButtonCollection'
import ContentLoading from 'components/ContentLoading'
import ErrorBlock from 'components/ErrorBlock'
import { useBrandingSettings } from 'hooks/branding'
import { useDocumentTitle } from 'hooks/document-title'
import { observer } from 'mobx-react'
import QS from 'qs'
import * as React from 'react'
import { useLocation } from 'react-router-dom'
import AuthenticationContainerState from '../AuthenticationContainerState'
import styles from '../styles.sass'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  controller: AuthenticationContainerState
}

export default observer(function Login({ controller }: Props) {
  const location = useLocation()
  const qs = QS.parse(location.search, { ignoreQueryPrefix: true })
  React.useEffect(() => {
    controller.handleParams(qs)
  }, [location])

  useDocumentTitle('Welcome')

  const { logoPrimary, workspaceName } = useBrandingSettings()

  return (
    <div className={styles.authenticator} data-test="LoginView">
      {controller.handleParams.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ErrorBlock error={err} />,
        resolved: () =>
          qs.show ? (
            <ContentLoading />
          ) : (
            <>
              <div className={styles.logo}>
                <img src={logoPrimary} />
              </div>
              <div className={styles.content}>
                <div className={styles.text}>
                  <h3>Welcome to {workspaceName}</h3>
                  <p>Please log in or sign up.</p>
                </div>
                <div className={styles.buttonContainer}>
                  <ButtonCollection>
                    <Button
                      data-test="LoginButton"
                      type="primary"
                      onClick={() => controller.authorize('login')}
                    >
                      Log In
                    </Button>
                    <Button
                      data-test="SignupButton"
                      type="secondary"
                      onClick={() => controller.authorize('signUp')}
                    >
                      Sign Up
                    </Button>
                  </ButtonCollection>
                </div>
              </div>
            </>
          ),
      })}
    </div>
  )
})
